import { REGEX } from 'src/app/core/constants/regex';

export function SnakeToTitleCase(snakeCasedString: string): string {
  let splittedStr = snakeCasedString.toLowerCase().split('_');
  splittedStr[0] = splittedStr[0].toLowerCase().replace(REGEX.FIRST_DIGIT, (L) => L.toUpperCase());
  return splittedStr.join(' ');
}
